import { SubcalendarList, Subcalendar, CalendarIcon, CalendarLine } from './styles'

const Account = ({ email, pullCalendars, kind }) => (
  <div>
    <CalendarLine>
      <CalendarIcon provider={kind} />
      {email}
    </CalendarLine>
    <SubcalendarList>
      {
        pullCalendars.map((item) => <Subcalendar key={item.id}>{item.name}</Subcalendar>)
      }
    </SubcalendarList>
  </div>
)

export default Account
